import { watch, computed, toRef } from "vue";

const USCustomerKeys = ["taxId", "tnc"];
const CACustomerKeys = ["occupation"];

export default function useIdentityCountryMixin() {
  const triggerRequiredFieldSchemaChange = (store, keys, isRequired) => {
    keys.forEach((key) => store.updateRequiredFieldForKey(key, isRequired));
  };

  const updateFormVmodels = (form, keys, toDelete = false) => {
    if (toDelete) {
      keys.forEach((key) => delete form.value[key]);
    } else {
      keys.forEach((key) => {
        if (key === "tnc") form.value.tnc = false;
        else form.value[key] = "";
      });
    }
  };

  const watchCountryAndUpdateStoreHandler = (form, store, callback) => {
    watch(
      () => form.value.country,
      (newCountry, oldCountry) => {
        if (!newCountry) {
          return;
        }
        const country = newCountry.toLowerCase();
        // reset; may need to revisit when adding other complex country requirements
        const allKeys = [...USCustomerKeys, ...CACustomerKeys];

        // remove all keys first
        triggerRequiredFieldSchemaChange(store, allKeys, false);
        updateFormVmodels(form, allKeys, true);

        switch (country) {
          case "united states":
            triggerRequiredFieldSchemaChange(store, USCustomerKeys, true);
            updateFormVmodels(form, USCustomerKeys);
            break;
          case "canada":
            triggerRequiredFieldSchemaChange(store, CACustomerKeys, true);
            updateFormVmodels(form, CACustomerKeys);
            break;
        }

        if (callback) {
          callback();
        }
      },
      { immediate: true }
    );
  };

  return {
    watchCountryAndUpdateStoreHandler,
  };
}
